import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperplane12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPaperplane12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.446 6.894a1 1 0 0 0 0-1.789L2.45 1.108a1 1 0 0 0-1.43 1.078L1.73 6l-.71 3.813a1 1 0 0 0 1.43 1.078zM2.003 2.003 9.999 6 2.003 9.996l.65-3.496h3.045a.5.5 0 0 0 0-1H2.653z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperplane12);
